
export default window.PtDesktopApi